import { useState } from "react";
import Modal from "react-modal";
import DataFetch from "../images/OpenIcon.svg";

import { AddModalStyles } from "../styles/CustomModalStyles";
import ItemsAutocomplete, { ItemsAutocompleteProps } from "./ItemsAutocomplete";
import Items from "../components/modules/asset/masters/items/Index";
import { PageFor } from "../utils/Enum.types";

const ItemSelect = ({
  onChange,
  onKeyDown,
  value,
  label,
  autoFocus,
  QueryType,
  isComponent,
}: ItemsAutocompleteProps) => {
  const [itemModal, setItemModal] = useState(false);

  return (
    <>
      <ItemsAutocomplete
        onChange={onChange}
        onKeyDown={onKeyDown}
        value={value}
        label={label ? label : ""}
        autoFocus={autoFocus}
        QueryType={QueryType}
        placeholder=""
        isComponent={isComponent}
      />
      {label ? (
        <img
          src={DataFetch}
          alt=""
          onClick={() => setItemModal(!itemModal)}
          className="data-fetch-icon"
        />
      ) : null}

      <Modal isOpen={itemModal} ariaHideApp={false} style={AddModalStyles}>
        <Items setModalFlag={setItemModal} pageType={PageFor.MODAL} />
      </Modal>
    </>
  );
};

export default ItemSelect;
